export default __webpack_public_path__ + "static/media/address.528c98ed.jpg";